import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import CategoryChart from "./CategoryChart";

const CategoryChartsPage = ({ text, data, months, userCurrency }) => {
  if (!data) return <Typography>Loading charts...</Typography>;

  const isYearlyView = data.years !== undefined;
  const title = isYearlyView ? "Category Breakdown (Yearly View)" : `Category Breakdown (${text})`;

  const incomeData = data.income || [];
  const incomeAvg = incomeData.length ? incomeData.reduce((a, b) => a + b.amount, 0) / incomeData.length : 1; 

  return (
    <Box>
      <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>
        {title}
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns="repeat(auto-fit, minmax(450px, 1fr))"
        gap={2}
      >
        {["income", "expenses", "investments", "savings"].map((category) => (
          <Paper 
            key={category} 
            sx={{ 
              p: 2, 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center",
              minHeight: "300px"
            }}
          >
            <Typography variant="h6" sx={{ textAlign: "center", mb: 1 }}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </Typography>
            <Box sx={{ width: "100%", maxWidth: "550px", height: "100%", flexGrow: 1 }}>
              <CategoryChart category={category} data={data[category]} isYearlyView={isYearlyView} incomeAvg={incomeAvg} months={months} userCurrency={userCurrency} />
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default CategoryChartsPage;
